import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconPhotoAlbum = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.30775 21.4984C5.80258 21.4984 5.375 21.3234 5.025 20.9734C4.675 20.6234 4.5 20.1958 4.5 19.6907V4.30616C4.5 3.801 4.675 3.37341 5.025 3.02341C5.375 2.67341 5.80258 2.49841 6.30775 2.49841H17.6923C18.1974 2.49841 18.625 2.67341 18.975 3.02341C19.325 3.37341 19.5 3.801 19.5 4.30616V19.6907C19.5 20.1958 19.325 20.6234 18.975 20.9734C18.625 21.3234 18.1974 21.4984 17.6923 21.4984H6.30775ZM6.30775 19.9984H17.6923C17.7692 19.9984 17.8398 19.9663 17.9038 19.9022C17.9679 19.8382 18 19.7677 18 19.6907V4.30616C18 4.22916 17.9679 4.15866 17.9038 4.09466C17.8398 4.0305 17.7692 3.99841 17.6923 3.99841H16V10.5562L13.75 9.20991L11.5 10.5562V3.99841H6.30775C6.23075 3.99841 6.16025 4.0305 6.09625 4.09466C6.03208 4.15866 6 4.22916 6 4.30616V19.6907C6 19.7677 6.03208 19.8382 6.09625 19.9022C6.16025 19.9663 6.23075 19.9984 6.30775 19.9984ZM7.3655 17.7484H16.7115L13.6538 13.6714L11.077 17.0177L9.4615 14.9677L7.3655 17.7484Z",
		fill: "black"
	})
});
export default SvgIconPhotoAlbum;
